import React from 'react';
import Icon from './Icon';
import {Button} from "./Button";
import Modal from "./Modal";
import {TextAreaField} from "./FormField";

class Report extends React.Component {
    constructor(props) {
        super(props);
        this.initialReport = {
            message: "",
            kind: this.props.kind,
        };
        this.state = {
            report : this.initialReport,
            error: false,
            toggle: false,
        };
        this.handleReport = this.handleReport.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleReport(value){
        this.setState({report : {...this.state.report, message: value}})
    }

    handleSubmit() {
        if(this.state.report.message.length >= 1){
            this.props.handleReport(this.state.report.message);
            this.setState({showValidation: true, toggle: false, report: this.initialReport});
        } else {
            this.setState({error: true});
        }
    }

    render() {
        return (
            <div className="report">
                <div className="report-comment">
                    {this.props.type === 'comment' ? (
                        <div onClick={() => this.setState({toggle: true})}><Icon type="report"/> Signaler</div>
                    ) : this.props.type === 'button' ? (
                        <Button size={"small"}
                                btnStyle={"cancel-reverse"}
                                onClick={() => this.setState({toggle: true})}
                                content={"Signaler"}/>
                    ) : this.props.type === 'button-answer' ? (
                        <Button size={"small"}
                                btnStyle={"cancel"}
                                onClick={() => this.setState({toggle: true})}
                                content={"Signaler"}/>
                    ) : (
                        <div className="base-report"
                             onClick={() => this.setState({toggle: true})}>Signaler</div>
                    )}
                    <Modal toggle={this.state.toggle} handleClose={() => this.setState({toggle: false})}>
                        <div className="report-popup modal-container">
                            <div className={"modal-topline"}>Signaler {this.props.title ? ` : ${this.props.title}` : " un contenu sur Voissa"}</div>
                            <div className={"modal-body"}>
                                <p> Signalez ici un comportement ou contenu qui ne respecte pas la charte de notre
                                    communauté</p>
                                <p className="red"><b>Donnez nous un maximum d’informations pour que nous puissions
                                    agir:</b></p>
                                <TextAreaField placeholder={"Raison de votre signalement ..."}
                                               value={this.state.report.content}
                                               onChange={(event)=>this.handleReport(event.target.value)}/>
                            </div>
                            <div className={"modal-baseline"}>
                                {this.state.error && (
                                    <p className={"warning"}>Vous n'avez pas mis de message</p>
                                )}
                                <Button size={"small"}
                                        btnStyle={"grey"}
                                        onClick={() => this.setState({toggle: false})}
                                        content={"Annuler"}/>
                                <Button size={"small"}
                                        btnStyle={"primary-reverse"}
                                        onClick={() => this.handleSubmit()}
                                        content={"Envoyer"}/>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default Report;
